import { useContext } from 'react';
import TrackWrapper from '@/common/TrackWrapper';
import { contentWithNavStyles, TileGrid } from '@/new-cars/new-cars.styles';
import YearCard from '@/new-cars/YearSection/YearCard';
import SectionName from '~/constants/new-cars/SectionName';
import { SECTION_VIEW_THRESHOLD } from '~/constants/new-cars/sectionViewThreshold';
import ParentModelContext from '~/context/new-cars/ParentModelContext';
import { withErrorBoundary } from '~/utilities/ErrorBoundary';

const viewEvent = {
  customAttributes: {
    action: 'viewed',
    level: 'Year',
    section: 'Year'
  },
  eventName: 'New Cars'
};

type OwnProps = {
  heading?: string;
};

function YearSection({ heading }: OwnProps) {
  const { selectedYear, years } = useContext(ParentModelContext);

  return (
    <TrackWrapper
      aria-labelledby="year-section-heading"
      element="section"
      event={viewEvent}
      threshold={SECTION_VIEW_THRESHOLD}
      trackOnce
      className={contentWithNavStyles}
    >
      <h2 className="text-text-strong t-heading-xl" id="year-section-heading">
        {heading ?? 'Select a year'}
      </h2>
      <TileGrid withNav>
        {years.results.map(year => (
          <YearCard
            key={year.next.year}
            selected={selectedYear?.year === year.next.year}
            year={year}
          />
        ))}
      </TileGrid>
    </TrackWrapper>
  );
}

export default withErrorBoundary<OwnProps>(YearSection, {
  section: SectionName.Year
});
